import QRCode from 'qrcode'
import { IManagedPaymentMethodDetails } from '../api/Radom'
import { getMethod } from './Managed'

async function loadImage(src: any): Promise<HTMLImageElement> {
  const image = new Image()
  image.crossOrigin = 'anonymous'
  return await new Promise((resolve) => {
    image.onload = () => {
      resolve(image)
    }
    image.src = src
  })
}

export async function generateQRCode(
  paymentMethodDetails: IManagedPaymentMethodDetails,
  darkColor: string = '#000000',
  lightColor: string = '#ffffff',
  drawRadius = true
): Promise<[string, string]> {
  const { network, token, paymentAddress } = paymentMethodDetails
  const paymentMethod = getMethod(network, token)

  const width = 500
  const height = 500

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height

  QRCode.toCanvas(
    canvas,
    paymentAddress,
    {
      errorCorrectionLevel: 'H',
      margin: 1,
      color: {
        dark: darkColor,
        light: lightColor
      },
      width: 500
    }
  )

  const ctx = canvas.getContext('2d')
  if (!ctx) {
    console.error('Failed to get canvas')
    return await Promise.reject(new Error('Failed to get canvas context'))
  }

  const img = await loadImage(paymentMethod.qrCodeImage || paymentMethod.logo)
  const maxLogoSize = 100

  ctx.beginPath()
  ctx.fillStyle = '#ffffff'

  const outlineSize = 20

  if (paymentMethod.tokenInfo) {
    const imgMax = Math.max(img.width, img.height)
    const imgWidth = img.width / imgMax * maxLogoSize
    const imgHeight = img.height / imgMax * maxLogoSize

    const centerX = (500 - imgWidth) / 2
    const centerY = (500 - imgHeight) / 2

    if (drawRadius && ctx.roundRect) {
      ctx.roundRect(
        200 - outlineSize / 2,
        200 - outlineSize / 2,
        maxLogoSize + outlineSize,
        maxLogoSize + outlineSize,
        90
      )
      ctx.fill()
    }

    const chainImage = await loadImage(paymentMethod.tokenInfo.logo)
    const chainImgMax = Math.max(chainImage.width, chainImage.height)
    const chainImgWidth = chainImage.width / chainImgMax * maxLogoSize / 2
    const chainImgHeight = chainImage.height / chainImgMax * maxLogoSize / 2

    if (drawRadius && ctx.roundRect) {
      ctx.roundRect(
        centerX + (maxLogoSize / 2) + outlineSize - 14,
        centerX + (maxLogoSize / 2) + outlineSize - 14,
        70,
        70,
        90
      )
      ctx.fill()
    }

    ctx.drawImage(img, centerX, centerY, imgWidth, imgHeight)
    ctx.drawImage(
      chainImage,
      centerX + maxLogoSize / 2 + outlineSize +
        ((Math.max(chainImgWidth, chainImgHeight) - chainImgWidth) / 2),
      centerY + maxLogoSize / 2 + outlineSize +
        ((Math.max(chainImgWidth, chainImgHeight) - chainImgHeight) / 2),
      chainImgWidth,
      chainImgHeight
    )
  } else {
    const imgMax = Math.max(img.width, img.height)
    const imgWidth = img.width / imgMax * maxLogoSize
    const imgHeight = img.height / imgMax * maxLogoSize

    const centerX = (500 - imgWidth) / 2
    const centerY = (500 - imgHeight) / 2

    if (drawRadius && ctx.roundRect) {
      ctx.roundRect(
        200 - outlineSize / 2,
        200 - outlineSize / 2,
        maxLogoSize + outlineSize,
        maxLogoSize + outlineSize,
        90
      )
      ctx.fill()
    }
    ctx.drawImage(img, centerX, centerY, imgWidth, imgHeight)
  }

  const newImg = canvas.toDataURL('image/png')
  return [newImg, paymentAddress]
}
